export class InvalidDurchwahlError extends Error {
  constructor(input: string) {
    super(`Ungültige Durchwahl: "${input}"`);
    this.name = 'InvalidDurchwahlError';
  }
}

export function toSipExtension(durchwahl: string, prefix: string): string {
  const d = durchwahl.trim();
  if (!/^\d{1,6}$/.test(d)) throw new InvalidDurchwahlError(durchwahl);
  return prefix + d;
}

/** Entfernt Leerzeichen, Klammern, Bindestriche, Schrägstriche und Punkte.
 *  Erlaubt: Ziffern, * und #, sowie ein einzelnes führendes +.
 *  Die ausgehenden Routen der FreePBX kennen nur Nummern mit führender 0, daher wird
 *  +49… zu 0… (national) und jede andere Landesvorwahl +… zu 00…. */
export function normalizeDialTarget(input: string): string | null {
  const cleaned = input.trim().replace(/[\s()\-/.]/g, '');
  if (!/^\+?[0-9*#]+$/.test(cleaned)) return null;
  if (cleaned.startsWith('+49')) return '0' + cleaned.slice(3);
  if (cleaned.startsWith('+')) return '00' + cleaned.slice(1);
  return cleaned;
}
